// src/components/Layout/Sidebar.js
import React from 'react';
import styles from './Sidebar.module.css';
import Logo from './Logo';
import NavigationTabs from './NavigationTabs';
import StatusDisplay from './StatusDisplay';

const Sidebar = ({
  activeTab,
  onTabChange,
  playerData,
  tooltipsEnabled = true
}) => {
  return (
    <div className={styles.sidebarContainer}>
      <Logo />
      
      {/* Ensure playerData and its nested properties exist before accessing */}
      {playerData && playerData.health && playerData.mana && playerData.energy && (
        <StatusDisplay
          health={playerData.health}
          mana={playerData.mana}
          energy={playerData.energy}
          tooltipsEnabled={tooltipsEnabled}
        />
      )}
      
      <NavigationTabs 
        activeTab={activeTab} 
        onTabChange={onTabChange} 
        playerData={playerData}
        currentLocation={playerData?.currentLocation}
        tooltipsEnabled={tooltipsEnabled}
      />
    </div>
  );
};

export default Sidebar;